import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import mixpanelConstants from '../../constants/mixpanel';

export const setAutoApproveRedux = createAction('SET_AUTO_APPROVE');
export const setRequirements = createAction('SET_REQUIREMENT');
export const setSearchString = createAction('SET_SEARCHSTRING');
export const setRequirementTitle = createAction('SET_REQUIREMENT_TITLE');
export const setRequirementFields = createAction('SET_REQUIREMENT_FIELDS');
export const setRequirementOptions = createAction('SET_REQUIREMENT_OPTIONS');
export const setCount = createAction('SET_COUNT');
export const setIsConnectrnReq = createAction('SET_IS_CONNECTRN_REQ');
export const setRequirementType = createAction('SET_REQUIREMENT_TYPE');
export const setIsMultiInstance = createAction('SET_IS_MULT_INS_REQ');
export const setIsCovidExtended = createAction('SET_IS_COVID_EXTENDED');
export const setMandatoryRoleType = createAction('SET_MANDATORY_ROLE_TYPE');
export const setMandatoryRoles = createAction('SET_MANDATORY_ROLES');
export const setMandatoryStateType = createAction('SET_MANDATORY_STATE_TYPE');
export const setMandatoryStates = createAction('SET_MANDATORY_STATES');
export const setIsLocSpecificExp = createAction('SET_IS_LOC_SPEC_EXPR_DATE');
export const setIsMandatory = createAction('SET_IS_MANDATORY');
export const setRequirementDetail = createAction('SET_REQUIREMENT_DETAIL');
export const setMsgDisplay = createAction('SET_MSG_DISPLAY');
export const setEditRequirementDetail = createAction('SET_EDIT_REQ_DETAIL');
export const setID = createAction('SET_ID');
export const setProtect = createAction('SET_PROTECT');
export const setMaskFormat = createAction('SET_MASK_FORMAT');
export const setReqDescription = createAction('SET_REQ_DESCRIPTION');

export const clearAutoApprove = createAction('CLEAR_AUTO_APPROVE');
export const clearIsConnectrnReq = createAction('CLEAR_IS_CONNECTRN_REQ');
export const clearRequirementType = createAction('CLEAR_REQUIREMENT_TYPE');
export const clearIsMultiInstance = createAction('CLEAR_IS_MULT_INS_REQ');
export const clearIsLocSpecificExp = createAction('CLEAR_IS_LOC_SPEC_EXPR_DATE');
export const clearRequirementTitle = createAction('CLEAR_REQUIREMENT_TITLE');
export const ClearReqDescription = createAction('CLEAR_REQ_DESCRIPTION');
export const ClearReqOptions = createAction('CLEAR_REQ_OPTIONS');
export const clearCount = createAction('CLEAR_COUNT');
export const clearProtect = createAction('CLEAR_PROTECT');
export const clearMaskFormat = createAction('CLEAR_MASK_FORMAT');
export const setIsFetching = createAction('SET_IS_FETCHING');
export const setFetchingDetail = createAction('SET_FETCHING_DETAIL');

const initialState = {
	doc_count: 0,
	editRequirementDetail: [],
	fetchingDetail: false,
	fields: '',
	id: 0,
	is_mandatory_roles_states_enabled: false,
	isConnectrn_req: false,
	isFetching: false,
	isLocSpecificExp: false,
	isMultiInsSupport: false,
	mask_format: '',
	msgDisplay: 'none',
	protect: false,
	req_options: '',
	req_type: 'document',
	reqDescription: '',
	requirementDetail: {},
	requirementList: [],
	requirementTitle: '',
	search_text: '',
	searchResult: []
};

export default handleActions(
	{
		CLEAR_AUTO_APPROVE: (state) => ({ ...state, doc_count: initialState.auto_approve }),
		CLEAR_COUNT: (state) => ({ ...state, doc_count: initialState.doc_count }),
		CLEAR_IS_CONNECTRN_REQ: (state) => ({
			...state,
			isConnectrn_req: initialState.isConnectrn_req
		}),
		CLEAR_IS_LOC_SPEC_EXPR_DATE: (state) => ({
			...state,
			isLocSpecificExp: initialState.isLocSpecificExp
		}),
		CLEAR_IS_MULT_INS_REQ: (state) => ({
			...state,
			isMultiInsSupport: initialState.isMultiInsSupport
		}),
		CLEAR_MASK_FORMAT: (state) => ({ ...state, mask_format: initialState.mask_format }),
		CLEAR_PROTECT: (state) => ({ ...state, protect: initialState.protect }),
		CLEAR_REQ_DESCRIPTION: (state) => ({
			...state,
			reqDescription: initialState.reqDescription
		}),
		CLEAR_REQ_OPTIONS: (state) => ({
			...state,
			req_options: initialState.req_options
		}),
		CLEAR_REQUIREMENT_TITLE: (state) => ({
			...state,
			requirementTitle: initialState.requirementTitle
		}),
		CLEAR_REQUIREMENT_TYPE: (state) => ({ ...state, req_type: initialState.req_type }),
		SET_AUTO_APPROVE: (state, action) => ({ ...state, auto_approve: action.payload }),
		SET_COUNT: (state, action) => ({ ...state, doc_count: action.payload }),
		SET_EDIT_REQ_DETAIL: (state, action) => ({ ...state, editRequirementDetail: action.payload }),
		SET_FETCHING_DETAIL: (state, action) => ({ ...state, fetchingDetail: action.payload }),
		SET_ID: (state, action) => ({ ...state, id: action.payload }),
		SET_IS_CONNECTRN_REQ: (state, action) => ({ ...state, isConnectrn_req: action.payload }),
		SET_IS_COVID_EXTENDED: (state, action) => ({ ...state, covid19DateExtended: action.payload }),
		SET_IS_FETCHING: (state, action) => ({ ...state, isFetching: action.payload }),
		SET_IS_LOC_SPEC_EXPR_DATE: (state, action) => ({ ...state, isLocSpecificExp: action.payload }),
		SET_IS_MANDATORY: (state, action) => ({ ...state, isMandatory: action.payload }),
		SET_IS_MULT_INS_REQ: (state, action) => ({ ...state, isMultiInsSupport: action.payload }),
		SET_MANDATORY_ROLE_TYPE: (state, action) => ({ ...state, mandatoryRoleType: action.payload }),
		SET_MANDATORY_ROLES: (state, action) => ({ ...state, mandatoryRoles: action.payload }),
		SET_MANDATORY_STATE_TYPE: (state, action) => ({ ...state, mandatoryStateType: action.payload }),
		SET_MANDATORY_STATES: (state, action) => ({ ...state, mandatoryStates: action.payload }),
		SET_MASK_FORMAT: (state, action) => ({ ...state, mask_format: action.payload }),
		SET_MSG_DISPLAY: (state, action) => ({ ...state, msgDisplay: action.payload }),
		SET_PROTECT: (state, action) => ({ ...state, protect: action.payload }),
		SET_REQ_DESCRIPTION: (state, action) => ({ ...state, reqDescription: action.payload }),
		SET_REQUIREMENT: (state, action) => ({ ...state, requirementList: action.payload }),
		SET_REQUIREMENT_DETAIL: (state, action) => ({ ...state, requirementDetail: action.payload }),
		SET_REQUIREMENT_FIELDS: (state, action) => ({ ...state, fields: action.payload }),
		SET_REQUIREMENT_OPTIONS: (state, action) => ({ ...state, req_options: action.payload }),
		SET_REQUIREMENT_TITLE: (state, action) => ({ ...state, requirementTitle: action.payload }),
		SET_REQUIREMENT_TYPE: (state, action) => ({ ...state, req_type: action.payload }),
		SET_SEARCH_RES: (state, action) => ({ ...state, searchResult: action.payload }),
		SET_SEARCHSTRING: (state, action) => ({ ...state, search_text: action.payload })
	},
	initialState
);

export const clearFormValues = () =>
	function (dispatch) {
		dispatch(clearIsConnectrnReq());
		dispatch(clearRequirementType());
		dispatch(clearIsMultiInstance());
		dispatch(clearIsLocSpecificExp());
		dispatch(clearRequirementTitle());
		dispatch(ClearReqDescription());
		dispatch(ClearReqOptions());
		dispatch(clearCount());
		dispatch(setEditRequirementDetail([]));
		dispatch(clearProtect());
		dispatch(clearMaskFormat());
		dispatch(clearAutoApprove());
	};

export const getRequirementList = () =>
	function (dispatch, getState) {
		let { search_text } = getState().requirement;

		if (search_text === '' || search_text == undefined) {
			search_text = undefined;
		}

		Agent.getRequirement(search_text).then((response) => {
			if (response.ok) {
				dispatch(setRequirements(response.data));
				mixpanel.track(mixpanelConstants.SEARCH_REQUIREMENTS, {
					searchText: search_text
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const addRequirements = () =>
	function (dispatch, getState) {
		const {
			auto_approve,
			requirementTitle,
			fields,
			req_options,
			doc_count,
			isConnectrn_req,
			req_type,
			isMultiInsSupport,
			protect,
			mask_format,
			isLocSpecificExp,
			isMandatory,
			covid19DateExtended,
			mandatoryRoleType,
			mandatoryRoles,
			mandatoryStates,
			mandatoryStateType,
			reqDescription
		} = getState().requirement;
		Agent.addRequirement(
			auto_approve,
			requirementTitle,
			doc_count,
			isConnectrn_req,
			req_type,
			isMultiInsSupport,
			isLocSpecificExp,
			isMandatory,
			fields,
			req_options,
			protect,
			mask_format,
			mandatoryRoleType,
			mandatoryStateType,
			mandatoryRoles,
			mandatoryStates,
			covid19DateExtended,
			reqDescription
		).then((response) => {
			if (response.ok) {
				dispatch(getRequirementList());
				mixpanel.track(mixpanelConstants.SAVE_NEW_REQUIREMENT, {
					covid19DateExtended,
					documentCount: doc_count,
					isConnectrnReq: isConnectrn_req,
					isLocSpecificExp,
					isMandatory,
					isMultiInsSupport,
					mandatoryRoles,
					mandatoryRoleType,
					mandatoryStates,
					mandatoryStateType,
					reqDescription,
					reqType: req_type,
					title: requirementTitle
				});
				alert('Requirement is Successfully Created!');
			} else {
				alert(response.data);
			}
		});
	};

export const deleteRequirements = (id) =>
	function (dispatch) {
		Agent.deleteRequirement(id).then((response) => {
			if (response.ok) {
				dispatch(getRequirementList());

				mixpanel.track(mixpanelConstants.DELETE_REQUIRED_DOCS, { reqId: id });
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const editRequirements = () =>
	function (dispatch, getState) {
		const { doc_count } = getState().requirement;
		const {
			auto_approve,
			id,
			requirementTitle,
			isConnectrn_req,
			req_type,
			isMultiInsSupport,
			isLocSpecificExp,
			isMandatory,
			fields,
			req_options,
			protect,
			mask_format,
			covid19DateExtended,
			mandatoryRoleType,
			mandatoryRoles,
			mandatoryStateType,
			mandatoryStates,
			reqDescription
		} = getState().requirement;
		dispatch(setIsFetching(true));
		Agent.editRequirement(
			auto_approve,
			id,
			requirementTitle,
			isConnectrn_req,
			req_type,
			isMultiInsSupport,
			isLocSpecificExp,
			fields,
			req_options,
			doc_count,
			protect,
			mask_format,
			isMandatory,
			covid19DateExtended,
			mandatoryRoleType,
			mandatoryStateType,
			mandatoryRoles,
			mandatoryStates,
			reqDescription
		).then((response) => {
			if (response.ok) {
				dispatch(setMsgDisplay('block'));
				dispatch(getRequirementsById(id));
				dispatch(getRequirementList());
				alert('Requirement has been updated!');
				dispatch(setIsFetching(false));
			} else {
				dispatch(setIsFetching(false));
				dispatch(handleError(response));
			}
		});
	};

export const getRequirementsById = (id) =>
	function (dispatch) {
		dispatch(clearFormValues);
		dispatch(setFetchingDetail(true));
		Agent.getRequirementById(id).then((response) => {
			dispatch(setFetchingDetail(false));
			if (response.ok) {
				dispatch(setEditRequirementDetail(response.data.fields));
				dispatch(setRequirementOptions(response.data.req_options));
				dispatch(setCount(response.data.required_doc_count));
				dispatch(setRequirementDetail(response.data));
				dispatch(setProtect(response.data.protect));
				dispatch(setMaskFormat(response.data.mask_format));
				dispatch(setIsLocSpecificExp(response.data.is_location_specific_auto_expiry));
				dispatch(setIsMandatory(response.data.is_mandatory_roles_states_enabled));
				dispatch(setAutoApproveRedux(response.data.auto_approve));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const resetRequirementVal = () =>
	function (dispatch) {
		dispatch(setSearchString(''));
	};
